<template>
  <div class="cp-sidebar__trans__info">
    <div class="cp-sidebar__trans__info__top">
      <span>#{{transaction.transaction_id}}</span>
      <span class="badge cp-badge" :class="transaction.badgeClass">{{transaction.status}}</span>
    </div>
    <div class="cp-sidebar__trans__info__item">
      <div class="cp-sidebar__trans__info__item__price" :class="{'refund-price': transaction.isRefund}">
        <span>{{transaction.amount}}</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TransactionInfo',
  props: {
    transaction: Object
  }
}

</script>

<style scoped>

</style>
